/**
 * Typed wrapper over the `/news/briefing` route (mounted at root `/news` in
 * apps/api). Used by the Daily Brief's personalized news section so `layout/`
 * code never issues a raw `fetch` (guard:no-raw-fetch). The News module
 * (`modules/news/`) still has its own raw-fetch client; this is the http-client
 * path with token rotation + workspace headers.
 */
import { http } from '@/lib/http'

export interface NewsBriefingSource {
  name: string
  url: string
}

export interface NewsBriefingStory {
  headline: string
  category?: string
  emoji?: string
  body: string
  sources: NewsBriefingSource[]
}

export interface NewsBriefingResponse {
  stories: NewsBriefingStory[]
  generatedAt?: string
}

/**
 * POST /news/briefing — synthesize a short news briefing for the given
 * free-text `instructions` (e.g. the user's comma-joined topics).
 */
export async function getNewsBriefing(
  instructions: string,
  authToken?: string | null,
): Promise<NewsBriefingResponse> {
  const res = await http.post<NewsBriefingResponse>(
    '/news/briefing',
    { instructions, tickers: [] },
    { authToken: authToken ?? undefined },
  )
  return res.data
}
